@if (kind() === 'file') {
    <a class="thumbnail" [href]="url()" target="_blank" rel="noopener" [attr.aria-label]="('attachmentPreview.open' | transloco) + ' ' + name()">
        <i class="fa-solid fa-file-lines" aria-hidden="true"></i>
    </a>
} @else {
    <button type="button" class="thumbnail" (click)="open()" [attr.aria-label]="('attachmentPreview.preview' | transloco) + ' ' + name()">
        @if (kind() === 'image') {
            <img [src]="url()" [alt]="name()" loading="lazy" decoding="async">
        } @else {
            <i class="fa-solid fa-file-pdf" aria-hidden="true"></i>
            <span>PDF</span>
        }
    </button>
}

@if (visible()) {
    <p-dialog [visible]="visible()" (visibleChange)="visible.set($event)" [modal]="true" [header]="name()"
        [draggable]="false" [resizable]="false" [style]="{ width: 'min(1100px, 96vw)' }"
        [breakpoints]="{ '640px': '100vw' }" styleClass="attachment-preview-dialog">
        <div class="preview-layout">
            <aside class="preview-summary">
                <i [class]="kind() === 'pdf' ? 'fa-solid fa-file-pdf' : 'fa-solid fa-image'" aria-hidden="true"></i>
                <small>{{ 'attachmentPreview.label' | transloco }}</small>
                <strong>{{ name() }}</strong>
                <span>{{ (kind() === 'pdf' ? 'attachmentPreview.pdf' : 'attachmentPreview.image') | transloco }}</span>
            </aside>
            <div class="preview-content">
                @if (kind() === 'image') {
                    <img [src]="url()" [alt]="name()">
                } @else if (previewUrl()) {
                    <iframe [src]="previewUrl()" [title]="name()"></iframe>
                }
            </div>
        </div>
        <ng-template #footer>
            <a pButton [href]="url()" target="_blank" rel="noopener" severity="secondary" [outlined]="true">
                <i class="fa-solid fa-arrow-up-right-from-square" aria-hidden="true"></i><span>{{ 'attachmentPreview.openOriginal' | transloco }}</span>
            </a>
            <button pButton type="button" (click)="visible.set(false)"><span>{{ 'attachmentPreview.close' | transloco }}</span></button>
        </ng-template>
    </p-dialog>
}
